import { TeamsApi } from "@/Stub/V1";
import { BaseApiConfig } from "@/Service/Api/V1/BaseApiConfig";

export const TeamsApiClient = new TeamsApi(BaseApiConfig);